module.exports = __webpack_public_path__ + "static/media/42x42-12.fccd8f1d.png";